/**
 * Centralized backend configuration.
 * Single source of truth for API URLs.
 * All files should import from here instead of reading env vars directly.
 */

const raw = import.meta.env.VITE_BACKEND_API_URL;

// Fail fast: in production, the env var MUST be set via Doppler
if (!raw && import.meta.env.PROD) {
  throw new Error(
    "[Nordex] VITE_BACKEND_API_URL is not set. " +
    "This is required in production. Check your Doppler configuration."
  );
}

/** Backend API base URL (e.g. https://dev-api.nordex.trade) */
export const API_BASE_URL: string = raw || "http://localhost:4000";

/** Backend WebSocket base URL (e.g. wss://dev-api.nordex.trade) */
export const WS_BASE_URL: string =
  import.meta.env.VITE_BACKEND_WS_URL || API_BASE_URL.replace(/^http/, "ws");

